import { gql, useQuery } from '@apollo/client';

import {
  useSponsorTierData_sponsorData,
  useSponsorTierData_sponsorDataVariables,
  useSponsorTierData_sponsorData_organization_result,
} from './graphql-types/useSponsorTierData_sponsorData';

const SPONSOR_DATA_QUERY = gql`
  query useSponsorTierData_sponsorData($input: SingleOrganizationInput!) {
    organization(input: $input) {
      result {
        _id
        sponsorship {
          currentTier {
            sponsoredPostsIntervalEndDate
            numSponsoredPostsRemaining
            shouldShowUpgradeCTA

            postUpgradeText {
              title
              subtitle
            }
          }
        }

        currentUserOrganizationPermission {
          canCreateOrganizationSponsoredPosts
        }
      }
    }
  }
`;

export const useSponsorTierData = (
  organizationId: string
): {
  loading: boolean;
  data?: useSponsorTierData_sponsorData_organization_result;
} => {
  const { loading, data } = useQuery<
    useSponsorTierData_sponsorData,
    useSponsorTierData_sponsorDataVariables
  >(SPONSOR_DATA_QUERY, { variables: { input: { id: organizationId } } });

  return {
    loading,
    data: data?.organization?.result ?? undefined,
  };
};
